import { useEffect } from "react";
import queryString from 'query-string';
import { dayDefaultAvailableState } from "src/SearchHours/components/calendars/state/atoms";
import { useRecoilState, useSetRecoilState } from "recoil";
import useSearchHours from "src/SearchHours/hooks/useSearchHours";
import { filterSearchSelectedState } from "src/SearchHours/state/atoms";

const ReagendarHora = () => {
    const query = queryString.parse(window.location.search)
    const [dayDefaultAvailable, setDayDefaultAvailable] = useRecoilState(dayDefaultAvailableState);
    const setFilterSearchSelected = useSetRecoilState(filterSearchSelectedState);
    //const { loadDReservationCanceled, getDaysAvailable } = useSearchHours();
    const { loadDReservationCanceled, loadDaysAvailableAndDefault } = useSearchHours();
    
    useEffect(() => {
        (async function () {
            if (query.ra_id && query.ra_id !== "") {
                const res = await loadDReservationCanceled(query.ra_id);
                
                if (res.data && res.data.length > 0 && !dayDefaultAvailable) {
                    setFilterSearchSelected((current) => ({
                        ...current,
                        specialitySelected: {
                            code: null,
                            value: null
                        },
                        professionalSelected: {
                            ...current.professionalSelected,
                            code: res.data[0].ptdRut,
                            value: res.data[0].ptdNombre
                        }
                    }))
                    const dateDefault = new Date(res.data[0].ageInicio.split(" ")[0].replace(/-/g, "/"));
                    //setDayDefaultAvailable(dateDefault);
                    sessionStorage.setItem("dateReservationCanceled", dateDefault)

                    //await getDaysAvailable();
                    setTimeout(() => {
                        loadDaysAvailableAndDefault()
                    }, 0)
                }
            }
        })()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return null;
}

export default ReagendarHora